import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Observable, timer } from 'rxjs';
import { scan, takeWhile } from 'rxjs/operators';

import { AuthService } from '../../services/auth.service';
import { UserStateService } from '../../services/users/user-state.service';

@Component({
  selector: '[unauthorized-toast-component]',
  templateUrl: './unauthorized-toast.component.html',
  styleUrls: ['./unauthorized-toast.component.scss'],
})
export class UnauthorizedToastComponent extends Toast {
  isLoading = false;
  isSuccessMessageVisible = false;
  timer$: Observable<number>;

  constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
    private authService: AuthService,
    private userStateService: UserStateService,
  ) {
    super(toastrService, toastPackage);

    this.timer$ = timer(0, 1000).pipe(
      scan((acc) => {
        return --acc;
      }, 60),
      takeWhile((x) => {
        return x >= 0;
      }),
    );
  }

  logout() {
    this.toastPackage.triggerAction('logout');
    this.remove();
  }

  refreshToken() {
    this.isLoading = true;

    const creds = this.userStateService.userCredentials;

    this.authService.login(creds).subscribe({
      next: (_token) => {
        this.isLoading = false;

        this.toastPackage.triggerAction();
        this.remove();
      },
      error: (error: unknown) => {
        this.isLoading = false;
        this.toastrService.error(error as string);
      },
    });
  }
}
